<script lang="ts">
    import {BarLoader, Circle2, Square} from 'svelte-loading-spinners'

    export let design = 'bar';
</script>

<span>
    {#if design === 'bar'}
        <BarLoader />
    {:else if design === 'square'}
        <Square />
    {:else if design === 'calm'}
        <Circle2 />
    {/if}
</span>
